<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getUserInfo } from './RNApp'
import userMixin from './mixin/user.mixin'
import { verdictEmpty } from '@/utils/tools'

export default {
  name: 'app',
  data() {
    return {}
  },
  beforeMount() {
    this.getUserInfoFromNative()
  },
  mounted() {
    this.$nextTick(() => {
      getUserInfo(this.getRnInfo)
    })
  },
  mixins: [userMixin],
  methods: {
    ...mapActions(['setUserInfo', 'setSystemInfo']),
    getRnInfo(type, data) {
      if (type === 'user') {
        let user = JSON.parse(data)
        if (user || verdictEmpty(user)) {
          return
        }
        this.setUserInfo(user)
      }
      if (type === 'system') {
        let system = JSON.parse(data)
        if (system || verdictEmpty(system)) {
          return
        }
        this.setSystemInfo(system)
      }
    }
  }
}
</script>
<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  .Router {
    position: absolute;
    height: 100%;
    width: 100%;
    transition: all .277s ease;
    top: 0;

  }

  .slide-left-enter,
  .slide-right-leave-active {
    opacity: 0.5;
    transform: translate3d(-100%, 0, 0);
  }

  .slide-left-leave-active,
  .slide-right-enter {
    opacity: 0.5;
    transform: translate3d(100%, 0, 0);
  }

  .fade-enter {
    opacity: 0;
  }

  .fade-enter-to {
    opacity: 1;
  }

  .fade-enter-active {
    transition: all 0.3s;
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
